// extracted by mini-css-extract-plugin
module.exports = {"header":"components-UnauthorizedAppHeader-UnauthorizedAppHeader__header--333_T","spacer":"components-UnauthorizedAppHeader-UnauthorizedAppHeader__spacer--36rYH"};